import { c as _c } from "react/compiler-runtime";
import { useMemo } from "react";
import { useCalendarSettings } from "./useCalendarSettings";
import { getCalendarConnection } from "../utils/calendarConnection";
import type { CalendarConnection } from "../utils/calendarConnection";
export type UseCalendarConnectionResult = CalendarConnection & {
  isLoading: boolean;
  isError: boolean;
  refetch: () => void;
};

/**
 * Hook for "do we have a calendar?" and primary source.
 * Uses GET /user/settings/calendar (user_external_services only).
 * Use this on the calendar page and anywhere you need to show/hide calendar UI or the "connect calendar" prompt.
 */
export function useCalendarConnection(options) {
  const $ = _c(7);
  const {
    data,
    isLoading,
    isError,
    refetch
  } = useCalendarSettings(options);
  let t0;
  if ($[0] !== data) {
    t0 = getCalendarConnection(data);
    $[0] = data;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const connection = t0;
  let t1;
  if ($[2] !== connection || $[3] !== isError || $[4] !== isLoading || $[5] !== refetch) {
    t1 = {
      ...connection,
      isLoading,
      isError,
      refetch
    };
    $[2] = connection;
    $[3] = isError;
    $[4] = isLoading;
    $[5] = refetch;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  return t1;
}